// UX-CRM-03: single source of truth for the Lead module's 5-tab taxonomy — replaces the earlier
// 5-column Kanban (`lib/leadStages.js`, still used for stage LABELS/colors, just not as a board
// layout anymore) per explicit user request. A lead's TAB is derived, never stored — no new
// backend field, no migration:
//   - "New Lead": stage=new_lead, captured TODAY (local time)
//   - "Lead Pipeline": stage=new_lead, captured any earlier day (staff didn't act on it yet)
//   - "Contacted": stage is contacted/interested/demo_trial/negotiation (the 3 dropped stages
//     from the old Kanban live on here as a sub-status, not a separate tab)
//   - "Converted / Member": stage=converted, AND the conversion itself happened today — older
//     conversions are members now, not shown here at all (by design)
//   - "Lost": stage=lost
export const LEAD_TABS = [
  { key: "new_lead", label: "New Lead" },
  { key: "pipeline", label: "Lead Pipeline" },
  { key: "contacted", label: "Contacted" },
  { key: "converted", label: "Converted / Member" },
  { key: "lost", label: "Lost" },
];

export const CONTACTED_SUB_STATUSES = [
  { key: "contacted", label: "Contacted" },
  { key: "interested", label: "Interested" },
  { key: "demo_trial", label: "Demo / Trial" },
  { key: "negotiation", label: "Negotiation" },
];

export function isToday(iso) {
  if (!iso) return false;
  return new Date(iso).toDateString() === new Date().toDateString();
}

export function leadTabKey(lead) {
  if (lead.stage === "lost") return "lost";
  if (lead.stage === "converted") return isToday(lead.updated_at) ? "converted" : null;
  if (lead.stage === "new_lead") return isToday(lead.created_at) ? "new_lead" : "pipeline";
  if (CONTACTED_SUB_STATUSES.some((s) => s.key === lead.stage)) return "contacted";
  return null;
}
